import React from 'react';
import {FaIcon} from '../../FaIcon';
import {renderNoted} from '../../elements/FilterNotesDisplay';

/**
 * El ⓘ de un bloque con notas de filtro (`state/panelFilterNotes.js`, tanda «Filtros que se
 * respetan»): por qué una métrica no se puede calcular con los filtros pedidos.
 *
 * Lleva SÓLO los motivos del «no aplica» (`texts`): las notas de las métricas que sí aplican
 * (plataformas parciales, costo sin atribuir) ya están escritas debajo del valor o del gráfico, y en
 * la tabla en el ⓘ de su columna; repetirlas acá era un cartel que tapaba la lista con las mismas
 * frases (QA-VIS-filtrosfe-25). Sin motivos, no hay ⓘ.
 *
 * Misma forma que `PanelCaveatsWarning` —el ⓘ gris informativo, en el encabezado, con teclado— y
 * por la misma razón: el cuerpo del panel tiene `overflow: hidden` y un cartel adentro se
 * recortaría. Lo ve también el cliente del portal: el «—» que tiene delante es de él.
 *
 * El cartel NO se ancla al ⓘ sino al encabezado del bloque (`_filter-notes.scss`): anclado al ícono
 * se cortaba contra el sidebar en la primera tarjeta, contra el borde de la ventana a 390 y por la
 * derecha en la última columna del portal (QA-filtrosfe-N01, QA-VIS-filtrosfe-20 y -21). Dentro del
 * encabezado cabe siempre, sin elegir un lado.
 */
export function PanelFilterNotesWarning({filterNotes}) {
    const texts = (filterNotes && filterNotes.texts) || [];
    if (!texts.length) return null;
    return (
        <span className="info-icon-container -stronger inf-caveat-warning inf-filter-notes-warning" tabIndex={0}
              aria-label={texts.join(' ')} data-testid="inf-filter-notes-warning">
            <FaIcon iconName="info-circle"/>
            <div className="warning-tooltip -rich">
                <div className="warning-tooltip-body">
                    {texts.map((text) => <p key={text} className="warning-tooltip-text">{renderNoted(text)}</p>)}
                </div>
            </div>
        </span>
    );
}
